export function clamp(v: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, v));
}

export function damp(current: number, target: number, dt: number, speed: number): number {
  return current + (target - current) * (1 - Math.exp(-speed * dt));
}

export function formatTime(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return '—';
  const clamped = Math.max(0, ms);
  const minutes = Math.floor(clamped / 60000);
  const seconds = Math.floor((clamped % 60000) / 1000);
  const millis = Math.floor(clamped % 1000);
  return `${minutes}:${seconds.toString().padStart(2, '0')}.${millis.toString().padStart(3, '0')}`;
}

export function formatSpeed(ms: number): number {
  return Math.round(Math.abs(ms) * 3.6);
}

export function esc(value: string): string {
  return value.replace(/[&<>"']/g, (char) => {
    switch (char) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      default:
        return '&#39;';
    }
  });
}

/** Shortest signed difference a-b on a loop of length `mod`. */
export function wrapDiff(a: number, b: number, mod: number): number {
  let delta = a - b;
  delta = ((delta % mod) + mod) % mod;
  if (delta > mod / 2) delta -= mod;
  return delta;
}

export function medalLabel(medal: string): string {
  switch (medal) {
    case 'gold':
      return 'Ouro';
    case 'silver':
      return 'Prata';
    case 'bronze':
      return 'Bronze';
    default:
      return 'Sem medalha';
  }
}
